import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: null,
};

const amadeusTokenSlice = createSlice({
  name: "amadeusToken",
  initialState,
  reducers: {
    setAmadeusToken: (state, action) => {
      state.token = action.payload;
    },
    clearToken: (state) => {
      state.token = null;
    },
  },
});

export const { setAmadeusToken, clearToken } = amadeusTokenSlice.actions;
export default amadeusTokenSlice.reducer;
